import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AlertAnalyzesDemoService } from 'src/app/design/demo-services/alert-analyzes-demo.service';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class AlertAnalyzesService {

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private demoService: AlertAnalyzesDemoService) { }

  getEmailSmsAlertDate(dateTime: string, rollupGroupCode: string, timePeriod: number): Observable<any> {
    
    var url = `${environment.scApiProtocol}://${environment.scApiHost}:${environment.scApiPort}/api/callboard/alertStat?dateTime=${dateTime}&rollupGroupCode=${rollupGroupCode}&timePeriod=${timePeriod}`;

    const loader = this.route.params.pipe(
      switchMap(bl => 
        (environment.demo ? this.demoService.get(timePeriod, rollupGroupCode) : this.http.get(url))
          .pipe(
            map((b: any) => b),
            catchError(error => of({
              isLoading: false, 
              isLoaded: false,
              isError: true,
              errorMessage: error.error instanceof ErrorEvent ? `an error occurred: ${error.error.message}` : `backend error: ${error.status} - ${error.message}`,
              data: {}
            }))
          )
      ),
      map((d: any) => {

        const ret = d.isError === true ? d : {

          name: d.Name,
          alerts: [] = d.Items,
          minWait: [] = d.MinWait,
          avgWait: [] = d.AvgWait,
          maxWait: [] = d.MaxWait,
          chartLabels: [] = d.ChartLabels,
          LastUpdated: environment.demo ? new Date().toLocaleString() : d.LastUpdated,
          isNotFound: d.Items.length === 0,

          isLoading: false,
          isLoaded: true,
          isError: false,
          errorMessage: ''
        };
        return ret;
      })
    );
    return loader;
  }
}
